import { ArrowRight, CalendarDays } from "lucide-react";
import { Reveal } from "./Reveal";
import { REGISTRATION_URL } from "./data";

const FINAL_BG = "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=2000&q=80";

export const FinalCta = () => (
    <section id="final-cta" className="relative overflow-hidden py-24 lg:py-36" data-testid="final-cta-section">
        <div className="absolute inset-0">
            <img src={FINAL_BG} alt="Rumah modern di sore hari" className="h-full w-full object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-[#071B37]/85" />
            <div className="absolute inset-0 bg-gradient-to-b from-[#071B37] via-transparent to-[#071B37]" />
        </div>
        <div className="relative mx-auto max-w-4xl px-5 text-center lg:px-8">
            <Reveal>
                <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-testid="final-cta-heading">
                    Jangan Sampai Keputusan KPR Hari Ini Jadi{" "}
                    <span className="font-accent italic text-gold-gradient">Beban Bertahun-tahun.</span>
                </h2>
                <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/80 sm:text-lg">
                    Bekali dirimu dengan pemahaman yang lebih baik sebelum mengambil keputusan properti. Mulai dari persyaratan, cicilan, biaya tambahan, hingga strategi pelunasan.
                </p>
                <a href={REGISTRATION_URL} target="_blank" rel="noopener noreferrer" data-testid="final-cta-button"
                    className="group mt-10 inline-flex items-center gap-2 rounded-full bg-[#DDB56C] px-10 py-5 text-lg font-extrabold text-[#071B37] shadow-[0_12px_40px_rgba(221,181,108,0.45)] transition-all duration-300 hover:-translate-y-1 hover:bg-[#e9cf9a] hover:shadow-[0_16px_48px_rgba(221,181,108,0.6)]">
                    Amankan Tempat di Kelas KPR
                    <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2.5} />
                </a>
                <p className="mt-6 flex items-center justify-center gap-2 text-sm text-white/70" data-testid="final-cta-schedule">
                    <CalendarDays className="h-4 w-4 text-[#DDB56C]" strokeWidth={1.5} />
                    Minggu, 15 November 2026 • Live via Zoom
                </p>
            </Reveal>
        </div>
    </section>
);
